import { SignUpComponent } from 'components';
import { APP_ROUTES } from 'constants/AppRoutes';

const SignUpUser = () => (
	<SignUpComponent dashboardLink={APP_ROUTES.DASHBOARD_USER} signInLink={APP_ROUTES.SIGN_IN_USER} />
);

export default SignUpUser;
